<template>
  <div>
    <el-card style="min-height: 640px">
      <el-row class="mb-16">
        <el-col :span="12" type="flex">
          <el-button @click="handleAdd" icon="el-icon-plus" type="primary" v-auth="'stores::product-manager::tag-add'">
            {{ $t('product-manager::tag::add_button') }}
          </el-button>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <span>{{ $t('product-manager::tag::search') }}：</span>
          <el-input
            :placeholder="$t('product-manager::tag::placeholder_search')"
            @keyup.enter.native="handlePageChange"
            class="search-input"
            prefix-icon="el-icon-search"
            v-model.trim="searchData.tagName"
          ></el-input>
        </el-col>
      </el-row>
      <z-table
        :columns="columns"
        :data="tableData"
        :pagination.sync="pagination"
        @page-change="handlePageChange"
        height="540px"
        v-loading="loading"
      >
        <template #operate="{ row }">
          <span>
            <el-button @click="handleEdit(row)" type="text" v-auth="'stores::product-manager::tag-edit'">
              {{ $t('product-manager::tag::table_edit') }}
            </el-button>
            <el-button
              @click="handleDel(row)"
              style="color: red"
              type="text"
              v-auth="'stores::product-manager::tag-delete'"
            >
              {{ $t('product-manager::tag::table_delete') }}
            </el-button>
          </span>
        </template>
      </z-table>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :title="isEdit ? $t('product-manager::tag::edit_button') : $t('product-manager::tag::add_button')"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form
        :model="propForm"
        :rules="rules"
        @submit.native.prevent
        class="demo-ruleForm"
        label-width="100px"
        ref="propForm"
      >
        <el-form-item :label="$t('product-manager::tag::form_name')" prop="name">
          <el-input v-model.trim="propForm.name"></el-input>
        </el-form-item>
      </el-form>
      <span class="footer_class" slot="footer">
        <el-button @click="dialogVisible = false">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button @click="saveSuccess" type="primary">{{ $t('system::common::btn::confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as Api from '@/server/product'
// import {getTagList} from '@/server/product'
const validateSpace = (rule, value, callback) => {
  if (!value.trim()) {
    callback(new Error('请输入内容'))
  } else {
    callback()
  }
}
export default {
  name: 'index',
  data() {
    return {
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0
      },
      rules: {
        name: [
          { required: true, message: this.$t('product-manager::tag::placeholder_name'), trigger: 'blur' }
          // { validator: validateSpace, trigger: 'blur' }
        ]
      },
      propForm: {
        name: '',
        id: ''
      },
      loading: false,
      isEdit: true,
      dialogVisible: false,
      tableData: [],
      searchData: {
        tagName: ''
      },
      columns: [
        {
          label: this.$t('product-manager::tag::table_no'),
          prop: 'id',
          type: 'index',
          fixed: 'left',
          width: '80'
        },
        {
          label: this.$t('product-manager::tag::table_name'),
          prop: 'tagName',
          minWidth: '150'
        },
        {
          label: this.$t('product-manager::tag::table_createTime'),
          prop: 'createTime',
          minWidth: '150'
        },
        {
          label: this.$t('product-manager::tag::table_handle'),
          fixed: 'right',
          width: '180',
          prop: 'operate'
        }
      ]
    }
  },
  mounted() {
    this.getTableData(this.searchData)
  },
  methods: {
    handlePageChange() {
      this.getTableData(this.searchData)
    },
    async getTableData(d) {
      const params = {
        ...this.pagination,
        ...d
      }
      this.loading = true
      Api.getTagList(params).then(res => {
        // console.log('data is ', res.data)
        if (res.data.code === this.$code) {
          this.tableData = res.data.data.items
          this.loading = false
          this.pagination.total = res.data.data.totalCount
        }
      })
    },
    handleEdit(row) {
      // console.log('row is ', row)
      this.isEdit = true
      this.dialogVisible = true
      // this.propForm = row
      this.propForm.name = row.tagName
      this.propForm.id = row.id
    },
    handleAdd() {
      this.isEdit = false
      this.propForm.name = ''
      this.dialogVisible = true
    },
    handleDel(row) {
      this.$confirm(
        this.$t('product-manager::prop::delete_tip'),
        this.$t('system::common::dialog::change_merchant_tooltip'),
        {
          confirmButtonText: this.$t('system::common::btn::confirm'),
          cancelButtonText: this.$t('system::common::btn::cancel')
        }
      ).then(() => {
        Api.deleteTag(row.id).then(res => {
          if (res.data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.handlePageChange()
          }
        })
      })
    },
    saveSuccess() {
      this.$refs.propForm.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            console.log('this.propForm', this.propForm)
            return Api.updateTag(this.propForm).then(res => {
              console.log('res is', res)
              if (res.data.code === this.$code) {
                this.$message.success(this.$t('system::tip::control_success'))
                this.handlePageChange()
                this.dialogVisible = false
              }
            })
          }
          Api.updateTag({ name: this.propForm.name }).then(res => {
            console.log('新增的name', this.propForm)
            if (res.data.code === this.$code) {
              this.$message.success(this.$t('system::tip::control_success'))
              this.handlePageChange()
              this.dialogVisible = false
            }
          })
        }
      })
    }
    // Api.updateTag({name: this.propForm.name}).then(res => {
    //     console.log('新增的name', this.propForm)
    //     if (res.data.code === this.$code) {
    //       this.$message.success('操作成功')
    //       this.handlePageChange()
    //       this.dialogVisible = false
    //     }
    //   })
    // }
  }
}
</script>

<style scoped>
.search-input {
  width: 180px;
}
</style>
